module.exports = __webpack_public_path__ + "static/media/mental_health.856a8511.jpg";